export const LOAD = 'ethstats/blockDifficulty/LOAD';
export const LOAD_SUCCESS = 'ethstats/blockDifficulty/LOAD_SUCCESS';
export const LOAD_FAIL = 'ethstats/blockDifficulty/LOAD_FAIL';
